import _typeof from "@babel/runtime/helpers/typeof";
export var renderArcWithWidth = function renderArcWithWidth(ctx, options) {
  var arcWidth = options.arcWidth,
    startAngle = options.startAngle,
    endAngle = options.endAngle,
    centerX = options.centerX,
    centerY = options.centerY,
    radius = options.radius;
  var halfArcWidth = arcWidth / 2;
  var x1 = centerX + (radius + halfArcWidth) * Math.cos(startAngle);
  var y1 = centerY + (radius + halfArcWidth) * Math.sin(startAngle);
  var x2 = centerX + (radius - halfArcWidth) * Math.cos(startAngle);
  var y2 = centerY + (radius - halfArcWidth) * Math.sin(startAngle);
  var x3 = centerX + (radius + halfArcWidth) * Math.cos(endAngle);
  var y3 = centerY + (radius + halfArcWidth) * Math.sin(endAngle);
  var x4 = centerX + (radius - halfArcWidth) * Math.cos(endAngle);
  var y4 = centerY + (radius - halfArcWidth) * Math.sin(endAngle);
  ctx.beginPath();
  ctx.arc(centerX, centerY, radius + halfArcWidth, startAngle, endAngle, false);
  var rightRadiusCenterX = (x3 + x4) / 2;
  var rightRadiusCenterY = (y3 + y4) / 2;
  ctx.arc(rightRadiusCenterX, rightRadiusCenterY, arcWidth / 2, endAngle, endAngle + Math.PI, false);
  ctx.arc(centerX, centerY, radius - halfArcWidth, endAngle, startAngle, true);
  var leftRadiusCenterX = (x1 + x2) / 2;
  var leftRadiusCenterY = (y1 + y2) / 2;
  ctx.arc(leftRadiusCenterX, leftRadiusCenterY, arcWidth / 2, startAngle + Math.PI, startAngle, false);
  ctx.closePath();
};
export var getPointAtArc = function getPointAtArc(centerX, centerY, radius, angle) {
  var x = centerX + radius * Math.cos(angle);
  var y = centerY + radius * Math.sin(angle);
  return [x, y];
};
export var shouldResetObjects = function shouldResetObjects(next, prev) {
  if (next.minValue && next.minValue !== prev.minValue) {
    return true;
  }
  if (next.maxValue && next.maxValue !== prev.maxValue) {
    return true;
  }
  if (next.ratio && next.ratio !== prev.ratio) {
    return true;
  }
  if (next.fillColor) {
    if (_typeof(next.fillColor) !== _typeof(prev.fillColor)) {
      return true;
    }
    if (Array.isArray(next.fillColor) && Array.isArray(prev.fillColor) && next.fillColor.join('_') !== prev.fillColor.join('_')) {
      return true;
    }
    if (next.fillColor !== prev.fillColor) {
      return true;
    }
  }
  if (next.meters) {
    if (next.meters.join('_') !== prev.meters.join('_')) {
      return true;
    }
  }
  return false;
};
var DEFAULT_FPS = 1000 / 60;
export var nextTick = window.requestAnimationFrame ? window.requestAnimationFrame : function (handler) {
  return setTimeout(handler, DEFAULT_FPS);
};
export var useAnimation = function useAnimation(duration, timingFunction, render) {
  var renderTimer = 0;
  var startTime = 0;
  var redraw = function redraw() {
    var progress = timingFunction((Date.now() - startTime) / duration);
    if (progress >= 1) {
      render(1);
      return;
    }
    render(progress);
    renderTimer = nextTick(redraw);
  };
  return {
    start: function start() {
      startTime = Date.now();
      redraw();
    },
    stop: function stop() {
      clearTimeout(renderTimer);
    }
  };
};